import React from 'react'

import { Box, styled } from '@driftt/dds'

import SalesRepSetupContainerV2 from 'components/SalesRepSetupV2'
const MainLayout = styled(Box, {
  maxWidth: '1096px',
  minWidth: '896px',
  margin: '0 auto',
  padding: '$4',
  paddingTop: '$3',
})

const SalesRepSetup = () => {
  return (
    <MainLayout>
      <SalesRepSetupContainerV2 />
    </MainLayout>
  )
}

export default SalesRepSetup
